import { FETCH_DEALER_SUCCESS } from 'constants/ActionTypes';
import { FETCH_GROUP_SUCCESS } from 'modules/groups/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../../actionTypes';

const initialState = {};

const cleanAuditModel = unformatted => {
  const { dealer, group, link: _link, ...formatted } = unformatted;
  return {
    ...formatted,
    dealerId: formatted.dealerId ?? dealer?.id,
    groupId: formatted.groupId ?? group?.id,
    createdById: formatted.createdById ?? formatted.createdBy?.id,
    modifiedById: formatted.modifiedById ?? formatted.modifiedBy?.id,
  };
};

/**
 * @param {Object} state
 * @param {FetchAuditModelAction}
 */
const updateOne = (state, { payload }) => ({
  ...state,
  [payload.auditModel.auditModelId]: {
    ...(state?.[payload.auditModel.auditModelId] ?? {}),
    ...cleanAuditModel(payload.auditModel),
  },
});

/**
 * @param {Object} state
 * @param {FetchAuditModelAction}
 */
const updateOneEntry = (state, { payload }) => ({
  ...state,
  [payload.auditModelId]: {
    ...(state?.[payload.auditModelId] ?? {}),
    ...cleanAuditModel(payload),
  },
});

const replaceOneEntry = (state, { payload }) => ({
  ...state,
  [payload.auditModelId]: cleanAuditModel(payload),
});

/**
 * @param {Object} state
 * @param {FetchAuditModelsAction}
 */
const updateAll = (state, { payload }) =>
  payload.content?.reduce((newState, auditModel) => updateOne(newState, { payload: { auditModel } }), state) ?? state;

/**
 * @param {Object} state
 * @param {import('modules/auditModels/types').DeleteAuditModelSuccessAction} action
 */
const deleteOne = (state, { payload: auditModelId }) => {
  const { [auditModelId]: _, ...newState } = state;
  return newState;
};

const updateAfterFetchConfig = (state, { payload: dealer }) => {
  const defaultAuditModels = Object.values(dealer.assignments?.defaultAuditModels ?? {}).reduce(
    (acc, assignments) => [...acc, ...Object.values(assignments).flat()],
    []
  );

  return defaultAuditModels.reduce((newState, auditModel) => {
    const auditModelId = auditModel.auditModelId ?? auditModel.id;
    return {
      ...newState,
      [auditModelId]: {
        ...(newState?.[auditModelId] ?? {}),
        ...cleanAuditModel({ ...auditModel, auditModelId }),
      },
    };
  }, state);
};

const updateAfterFetchConfigMatcher = ({ type, payload }) =>
  [FETCH_DEALER_SUCCESS, FETCH_GROUP_SUCCESS].includes(type) && payload.projectionType === 'config';

export default createReducer(
  initialState,
  {
    [actionTypes.FETCH_SUCCESS]: updateOne,
    [actionTypes.CREATE_SUCCESS]: updateOne,
    [actionTypes.UPDATE_SUCCESS]: updateOne,
    [actionTypes.GET_AUDIT_MODELS_SELECT_FETCH_SUCCESS]: updateAll,

    [actionTypes.FETCH_AUDIT_MODELS_MY_SUCCESS]: updateAll,
    [actionTypes.FETCH_AUDIT_MODELS_AVAILABLE_SUCCESS]: updateAll,
    [actionTypes.PATCH_AUDIT_MODEL_STATUS_SUCCESS]: updateOneEntry,
    [actionTypes.DEACTIVATE_AUDIT_MODEL_SUCCESS]: replaceOneEntry,
    [actionTypes.ACTIVATE_AUDIT_MODEL_SUCCESS]: replaceOneEntry,
    [actionTypes.DELETE_AUDIT_MODEL_SUCCESS]: deleteOne,
  },
  [
    {
      matcher: updateAfterFetchConfigMatcher,
      reducer: updateAfterFetchConfig
    }
  ]
);
